import { Component, Input } from '@angular/core';

import { DefaultModule, PrimeModule } from '@module';

import { DatePipe } from 'pn-core-code';

import { TagModule } from 'primeng/tag';

@Component({
  selector: 'shared-audit-field-detail',
  standalone: true,
  imports: [DefaultModule, PrimeModule, TagModule, DatePipe],
  templateUrl: './shared-audit-field-detail.component.html',
  styleUrl: './shared-audit-field-detail.component.scss'
})
export class SharedAuditFieldDetailComponent {
  @Input() createdAt: Date;
  @Input() createdUsername: string;
  @Input() updatedAt: Date;
  @Input() updatedUsername: string;
  @Input() width: string;


  // @Input() widthCol: string = 'w-1/3';
  // @Input() widthColLg: string = 'w-1/2 ';
  // @Input() widthContent: string = 'w-1/2 ';
  // @Input() widthContentLg: string = 'w-2/3';
}

